import React from 'react';
import {
  Button,
  Col,
  Container,
  Image,
  Row
} from 'react-bootstrap';
import QRCode from "react-qr-code";

export default function InvoiceQr() {
  return (
    <>
      <Container className="content-body g-0 mt-5">
        <Row>
          <Col />
          <Col xs={12} sm={8} md={4}>
            <QRCode
              size={256}
              style={{ height: "auto", maxWidth: "100%", width: "100%" }}
              value="https://www.meetbeep.com"
              viewBox={`0 0 256 256`}
            />  
            <h3 className="mt-3">$1,234.56</h3>
            <div><small>invoiced to</small></div>
            <div>Sean Pangia</div>
          </Col>
          <Col />
        </Row>  
      </Container>
    </>
  )
}